import { capitalizeInitials, Trackable } from '../utils';
import { Manager } from './manager';
import { SocialInfo } from './socialinfo';

export interface Company extends Trackable {
  id: number;
  /** field populated on front-end side, doesn't come from /company endpoint */
  accountManager?: any;
  accountManagerId: number;
  name: string;
  bio: string;
  city: string;
  countryCode: string;
  companyUrl: string;
  createdDate: string;
  createdById: string;
  createdByName: string;
  lastModifiedByName: string;
  streetAddress: string;
  state: string;
  stateCode: string;
  address: string;
  logoUrl: string;
  logoId: number;
  socialInfos: SocialInfo[];
  lastModifiedById: string;
  lastModifiedDate: string;
  parentId?: number;
  industry?: string;
  country?: string;
  countryName?: string;
  managers?: Manager[];
}

export class CompanyAutoOptionAdapter {
  static toOption(company: Company): any { // TODO: create better type
    return !!company && !!company.id
      ? {
        id: company.id,
        label: company.name,
        capitals: capitalizeInitials(company.name),
        imageId: company.logoId,
        option: company
      }
      : null;
  }
}
